import { useLabelsMetadataStore } from '@aibees/elephant/store/labels-metadata';
import { LabelVisibility } from '@aibees/elephant/types/label';
import { classnames } from '@aibees/shared/utils';
import { memo, useMemo } from 'react';
import { CardVisibilityTabs } from '../card-visibility-tabs';
import { config } from './config';
import * as Styled from './styles';
import * as SX from './sx';
import type { ListTableProps as Props } from './types';

const ListVisibilityTabs = memo(function ListVisibilityTabs() {
  const metadata = useLabelsMetadataStore((s) => s.metadata);
  const counts = useMemo(
    () =>
      metadata
        ? {
            private: metadata[LabelVisibility.PRIVATE],
            internal: metadata[LabelVisibility.INTERNAL],
          }
        : undefined,
    [metadata]
  );
  return <CardVisibilityTabs counts={counts} />;
});

const renderPrepend = () => <ListVisibilityTabs />;
const finalConfig = { ...config, renderTablePrependStable: renderPrepend };

export const ListTable = memo(({ className }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('ListTable', className)}
      sx={SX.root}
      config={finalConfig}
    />
  );
});

ListTable.displayName = 'ListTable';
